import jwt_decode from "jwt-decode";
import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import CookieConsent, { getCookieConsentValue, resetCookieConsentValue } from "react-cookie-consent";
import { mask, unMask } from "remask";
import logoColorido from "../../assets/logo-azulescura.png";
import logoBranco from "../../assets/logo-gradiente.png";
import AppFooter from "../../components/AppFooter";
import "./styles.scss";
//import axios from "axios";
import classNames from "classnames";
import { format } from "date-fns";
import { Button } from "primereact/button";
import Helmet from "react-helmet";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import QuickMenu from "../../components/QuickMenu";
import SimpleLoading from "../../components/SimpleLoading";
import { useGeneral } from "../../contexts/GeneralInfoContext";
import { Api } from "../../services/Api";
import { login } from "../../services/Auth";
import ValidaCNPJ from "../../utils/ValidaCNPJ";
import ValidaCPF from "../../utils/ValidaCPF";
// import QRCode from 'qrcode.react';
import iconWhats from "../../assets/icon-whats.png";
import { salvaLogCredor } from "../../services/requests/getUserInfo";
import { setLocal } from "../../utils/LocalStorageOps";
import ErrorPage from "../ErrorPage";

function Login() {
  const [cookieDeclined, setCookieDeclined] = useState(false);
  const [mouseOut, setMouseOut] = useState(false);
  const [tabChange, setTabChange] = useState(false);
  const [popupAlert, setPopupAlert] = useState(false);
  const [helpOpened, setHelpOpened] = useState(false);

  useEffect(() => {
    if (helpOpened) return;

    if (!mouseOut && !tabChange) return;
    setPopupAlert(true);
  }, [mouseOut]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      // console.log('executado', mouseOut)
      document.body.onmouseleave = function () {
        setMouseOut(true);
      };
      document.addEventListener("visibilitychange", setTabChange, true);
    }, 25000);

    const cookiesAccepted = getCookieConsentValue();
    if (cookiesAccepted === "false") resetCookieConsentValue();

    return () => {
      clearTimeout(timeout);
      document.body.onmouseleave = () => {};
    };
  }, [helpOpened]);

  const navigate = useNavigate();
  const {
    today,
    corGradiente1,
    corGradiente2,
    corGradiente3,
    corFonte,
    mostrarLogo,
    mostrarFooter,
    frontImage,
    logoImage,
    loadLayout,
    tituloPagina,
    avenidaDominio,
    pagueDiretoLogo,
    iconePagina,
    erroConexaoBackEnd,
    mensagemHome,
  } = useGeneral();
  const [checked, setChecked] = useState(false);
  const [checkedLGPD, setCheckedLGPD] = useState(false);
  const [showCookies, setShowCookies] = useState(getCookieConsentValue() === undefined ? "show" : "hidden");
  const [documento, setDocumento] = useState("");
  const [dataNascimento, setDataNascimento] = useState(null);
  const [loading, setLoading] = useState(false);
  const logoDinamico = classNames(logoImage === logoBranco ? "hidden" : "");

  const entrar = async (event) => {
    event.preventDefault();
    const DocValido = validarDocumento(unMask(documento));
    const DataValida = validarData(dataNascimento);
    const LoginData = {
      cpf: unMask(documento),
      data_nascimento: format(dataNascimento, "yyyy-MM-dd"),
    };
    console.log(getCookieConsentValue());
    if (!cookieDeclined) {
      if (DataValida) {
        if (DocValido) {
          setLoading(true);
          try {
            const { data } = await Api.post("/login/generica", LoginData);
            //const {data} = await axios.post('https://api.paguedireto.com.br/login/generica',LoginData)
            login(data.token);
            setLocal("limite-popup", 0);
            const decoded = jwt_decode(data.token);
            const multiploProvider = decoded.providers.length > 1 ? true : false;
            if (!multiploProvider) await logCredor(decoded);
            navigate("/dashboard");
            return data;
          } catch (error) {
            if (error.response === undefined) return toast.error("Erro de conexão com o servidor!");
            if (error.response.status === 500) return toast.error("Erro de conexão com o servidor!");
            if (error.response.status === 401)
              if (avenidaDominio)
                return toast.error(
                  "Seus dados não foram encontrados. Por favor, procure o atendimento das Lojas Avenida"
                );
              else return toast.error("Cliente não encontrado com essa combinação de documento e data");
          } finally {
            setLoading(false);
          }
        } else toast.error("Insira um CPF/CNPJ válido!");
      } else toast.error("Data inválida!");
    } else {
      toast.warn('Para acessar a plataforma é necessário aceitar o uso de "cookies" no seu dispositivo');
      setShowCookies("show");
      resetCookieConsentValue();
    }
  };

  const logCredor = async (decoded) => {
    const dadosLog = {
      id_usuario: decoded.usuario_id,
      action: "Login pague, escolha de provider",
      credor_id: decoded.providers[0].usuario_id,
    };
    try {
      await salvaLogCredor(dadosLog);
    } catch (error) {
      console.log(error);
    }
  };

  function validarDocumento(documento) {
    if (documento.length === 11) return ValidaCPF(documento);
    if (documento.length === 14) return ValidaCNPJ(documento);
    else return false;
  }

  function validarData() {
    if (dataNascimento < today) return true;
    else return false;
  }

  function handleHelpOpen(action = true) {
    setMouseOut(false);
    setHelpOpened(action);
  }
  if (!erroConexaoBackEnd)
    return (
      <>
        {loadLayout ? (
          <div
            className={`from-emerald-700 via-emerald-500 to-green-400 bg-gradient-to-br h-screen w-full`}
            style={{
              backgroundImage: `linear-gradient(to bottom right,${corGradiente1},${corGradiente2},${corGradiente3})`,
              color: corFonte,
            }}
          >
            <CookieConsent
              visible={showCookies}
              className=""
              location="bottom"
              style={{
                background: "#215445",
                justifyContent: "center",
                alignItems: "center",
                fontWeight: "700",
                marginBottom: "60px",
                textAlign: "-webkit-center",
              }}
              buttonText="Aceito"
              buttonStyle={{
                background: "green",
                width: 150,
                borderRadius: "20px",
                color: "white",
                fontWeight: "bolder",
                // textShadow: "2px 2px black",
              }}
              enableDeclineButton
              declineButtonText="Não aceito"
              declineButtonStyle={{
                background: "red",
                width: 150,
                borderRadius: "20px",
                color: "white",
                fontWeight: "bolder",
                // textShadow: "2px 2px black",
              }}
              onDecline={() => {
                setCookieDeclined(true);
                setShowCookies("hidden");
              }}
              onAccept={() => {
                setCookieDeclined(false);
                setShowCookies("hidden");
              }}
              hideOnAccept
              hideOnDecline
            >
              <p className="text-base text-left">
                Este site utiliza "cookies" para gerenciar a autenticação, navegação e outras funções.
              </p>
              <p className="text-base text-left">
                Ao usar nosso site, você concorda que podemos colocar esses tipos de cookies em seu dispositivo.
              </p>
            </CookieConsent>
            <Helmet>
              <title>{tituloPagina}</title>
              <link rel="icon" href={iconePagina} />
              <link rel="apple-touch-icon" href={iconePagina} />
              <meta name="description" content="Helmet application" />
            </Helmet>
            <div className="fixed h-screen left-0 z-0 md:flex hidden">
              <img src={frontImage} alt="sign" style={{ height: "100%" }}></img>
            </div>
            {/* <div className='z-50 fixed top-2 left-[20%]'>
        <img src="24952.png" alt='logo' style={{height:'100px'}} ></img>
    </div> */}
            {/* <Dialog
    visible
    >
        <QRCode 
        value="https://pix.bcb.gov.br/qr/MDAwMjAxMDEwMjEyMjY3NzAwMTRCUi5HT1YuQkNCLlBJWDI1NTVhcGkuaXRhdS9waXgvcXIvdjIvNDc3ZjgyMzItZmExYy00YmNmLWI2NjQtNzZjMDBhZWJlNWNhNTIwNDAwMDA1MzAzOTg2NTgwMkJSNTkyNVpvb3AgVGVjbm9sb2dpYSBFIE1laW9zIEQ2MDA5U0FPIFBBVUxPNjIwNzA1MDMqKio2MzA0MEYzRg=="
        
        ></QRCode>
    </Dialog> */}
            <SimpleLoading status={loading} />

            <div className="w-full lg:w-1/2 right-0 absolute font-lato dialog-persistente">
              {popupAlert && (
                <Dialog
                  className="w-[90%] sm:w-[80%] md:w-[70%] lg:w-[50%] xl:w-[35%] h-auto popup-persistente-login"
                  visible
                  header={
                    <img
                      className="mx-2"
                      src={logoColorido}
                      alt="direto-logo"
                      style={{ minHeight: "30px", maxHeight: "20px", width: "auto" }}
                    />
                  }
                  footer={true}
                  onHide={() => setPopupAlert(false)}
                >
                  <div className="grid w-full h-full md:text-left text-center justify-evenly">
                    <div className="flex">
                      <p className="text-lg">
                        <b>Obrigado por acessar a Pague Direto</b>
                      </p>
                      <p>.</p>
                    </div>
                    <div className="flex">
                      <h5 className="text-cyan-900">
                        <b></b>
                      </h5>
                      <p className="text-sm">
                        Esperamos que a sua experiência seja satisfatória, mas se você tiver qualquer dúvida, pode
                        entrar em contato com nosso suporte.
                      </p>
                    </div>
                    <div className="flex justify-center gap-2 mt-2">
                      <div className="flex text-center justify-center mt-2">
                        <a
                          target="_blank"
                          style={{ color: "white" }}
                          href="https://wa.me/5511996383405?text=Oi"
                          rel="noreferrer"
                        >
                          <div
                            className="flex px-5 py-1"
                            style={{ backgroundColor: "#25D366", borderRadius: 15, borderColor: "white" }}
                          >
                            <img
                              className="mx-2"
                              src={iconWhats}
                              alt="direto-logo"
                              style={{ height: "20px", width: "auto" }}
                            ></img>
                            <h6 className="font-lato text-sm">Suporte Whatsapp 1</h6>
                          </div>
                        </a>
                      </div>
                      <div className="flex text-center justify-center mt-2">
                        <a
                          target="_blank"
                          style={{ color: "white" }}
                          href="https://wa.me/5511988812431?text=Oi"
                          rel="noreferrer"
                        >
                          <div
                            className="flex px-5 py-1"
                            style={{ backgroundColor: "#25D366", borderRadius: 15, borderColor: "white" }}
                          >
                            <img
                              className="mx-2"
                              src={iconWhats}
                              alt="direto-logo"
                              style={{ height: "20px", width: "auto" }}
                            ></img>
                            <h6 className="font-lato text-sm">Suporte Whatsapp 2</h6>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </Dialog>
              )}
              <div className="items-start justify-items-center grid h-screen  pb-[10vh] md:pb-[5vh]">
                {/* <div className='w-screen h-[8vh] fixed top-0 left-0 z-10 flex justify-end
                            '>
                                <div className=' w-1/2 flex justify-around pt-[1vh]'>
                                    <button
                                    className=" bg-[#5CC140] px-4 border-2 border-slate-100 text-slate-100
                                    rounded-lg font-lato-bold flex gap-1 justify-center items-center h-3/4
                                    hover:bg-slate-100 hover:border-[#5CC140] hover:text-[#5CC140]
                                    transition text-[3vh]"
                                    >FAQ</button>
                                    <button
                                    className=" bg-[#5CC140] px-4 border-2 border-slate-100 text-slate-100
                                    rounded-lg font-lato-bold flex gap-1 justify-center items-center h-3/4
                                    hover:bg-slate-100 hover:border-[#5CC140] hover:text-[#5CC140]
                                    transition text-[3vh]"
                                    onClick={()=>navigate('/quem-somos')}
                                    >Quem Somos?</button>
                                </div>
                            </div> */}
                <div className="w-5/6 lg:h-1/6 xl:h-1/4 md:mt-[5vh] mt-[2vh] justify-center flex">
                  <img
                    className="w-auto h-[10vh] md:h-[10vh]"
                    src={logoImage}
                    alt="direto-logo"
                    // style={{ height: '13vh', width: "auto" }}
                  ></img>
                </div>
                <div
                  className={`card w-5/6 md:w-2/3 text-slate-700 shadow-2xl
             p-[4vh] bg-slate-100`}
                >
                  <form onSubmit={(e) => entrar(e)}>
                    <div className="mb-3 font-lato-bold">
                      <h5>{mensagemHome}</h5>
                    </div>
                    <div>
                      <h6>CPF/ CNPJ</h6>
                      <InputText
                        id="documento"
                        type="text"
                        //    aria-errormessage='CPF/CNPJ Vazio!'
                        required
                        placeholder="ex: 999.999.999-99"
                        value={documento}
                        onChange={({ target }) => {
                          setDocumento(mask(unMask(target.value), ["999.999.999-99", "99.999.999/9999-99"]));
                        }}
                      />
                    </div>
                    <div>
                      <h6>Data de Nascimento/ Criação da Empresa</h6>
                      <div className="loginCalendar">
                        <Calendar
                          value={dataNascimento}
                          maxDate={today}
                          locale="pt-BR"
                          dateFormat="dd/mm/yy"
                          onChange={(e) => {
                            setDataNascimento(e.value);
                            console.log(e.value);
                          }}
                          placeholder="ex: 21/06/1992"
                          showIcon
                          yearNavigator
                          yearRange="1900:2030"
                          inputMode="number"
                          showOnFocus={false}
                          id="nascimento"
                          required
                          mask="99/99/9999"
                        />
                      </div>
                    </div>
                    <div className="loginCheckbox mt-[1.5vh] font-lato">
                      <Checkbox className="loginCheckbox" onChange={(e) => setChecked(e.checked)} checked={checked} />
                      <label className="text-[1.4vh]">
                        Li e aceito os
                        <a
                          className="text-blue-600"
                          href={"/politica-de-privacidade-direto-techv1.pdf"}
                          target="_blank"
                          rel="noopener noreferer noreferrer"
                        >
                          &nbsp;Termos de Uso e Política de Privacidade
                        </a>
                      </label>
                    </div>
                    <div className="loginCheckbox w-[80%] sm:w-full mt-[1.5vh] font-lato">
                      <Checkbox
                        className="loginCheckbox"
                        onChange={(e) => setCheckedLGPD(e.checked)}
                        id="lgpd-checkbox"
                        checked={checkedLGPD}
                      />
                      <label className="text-[1.4vh]" htmlFor="lgpd-checkbox">
                        Você declara que os dados informados acima para visualizar suas informações e negociações são de
                        sua titularidade e se responsabiliza integralmente pela consulta a partir deles
                      </label>
                    </div>

                    <div className="loginButton mt-[4vh]">
                      <Button
                        label={cookieDeclined ? "Cookies recusados" : "Consulte"}
                        //style={{backgroundImage:"linear-gradient(#001d74)"}}
                        disabled={!checked || !checkedLGPD}
                        type="submit"
                      ></Button>
                      {/* <button className='bg-[#001d74] w-full h-[6vh] text-slate-50 p-2
                    hover:bg-gradient-to-b hover:from-[#0000ff] hover:to-[#0040ff] 
                    hover:shadow-[1.5px_1.5px_5px_5px_#4300fa85] transition duration-300
                    disabled:hover:from-[#001d74]/0 disabled:hover:to-[#001d74]/0 disabled:hover:shadow-none
                    text-[2.6vh] font-lato font-extrabold disabled:bg-[#001d74]/70 rounded-md mt-6' 
                    disabled={!checked}
                    type="submit"
                    >                  
                    Consulte  
                    </button> */}
                    </div>
                  </form>
                </div>
                <div className={"w-2/6 mt-[5vh]"}>
                  {mostrarLogo && <img src={pagueDiretoLogo} alt="cliente-logo" className={logoDinamico}></img>}
                </div>
              </div>
            </div>
            <QuickMenu handleSwitch={handleHelpOpen} selected={true} />
            <script
              type="text/javascript"
              src="https://sandbox.boletobancario.com/boletofacil/wro/direct-checkout.min.js"
            ></script>
          </div>
        ) : (
          <div>
            <SimpleLoading status={true} />
          </div>
        )}
        {mostrarFooter && <AppFooter />}
      </>
    );
  else
    return (
      <div
        style={{
          backgroundImage: `linear-gradient(to top left,${corGradiente1},${corGradiente2},${corGradiente3})`,
          color: corFonte,
        }}
      >
        <Helmet>
          <title>{tituloPagina}</title>
          <link rel="icon" href={iconePagina} />
          <link rel="apple-touch-icon" href={iconePagina} />
          <meta name="description" content="Helmet application" />
        </Helmet>
        <ErrorPage logo={pagueDiretoLogo} />
      </div>
    );
}

export default Login;
